import PropTypes from 'prop-types';
import React, { memo } from 'react';

// Imported directly rather than via the `@/hooks` barrel, which would pull in
// `utils/v2` and cycle back to this tag through `getLevelOfServiceTag`.
import useIsOverflowing from '@/hooks/useIsOverflowing';
import { MedicalServiceIcon } from 'assets/v2/icons';
import Tooltip from 'components/v2/Tooltip';

import { StyledTag, TagLabel } from './LevelOfServiceTag.styles';

const LevelOfServiceTag = ({ label, ...props }) => {
  // Level of service is free text and is routinely wider than the container it
  // renders in, so surface the full value on hover once it starts truncating.
  // `observedValue` re-measures when the label changes in place (e.g. switching
  // trips in the Trip Map detail panel, which never remounts this tag).
  const [isOverflowing, labelRef] = useIsOverflowing({ observedValue: label });

  return (
    <Tooltip
      title={label}
      disableHoverListener={!isOverflowing}
      disableFocusListener={!isOverflowing}
      disableTouchListener={!isOverflowing}
    >
      <StyledTag
        label={<TagLabel ref={labelRef}>{label}</TagLabel>}
        icon={<MedicalServiceIcon />}
        {...props}
      />
    </Tooltip>
  );
};

LevelOfServiceTag.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(LevelOfServiceTag);
